import { client } from '@/src/provider/MbaasClient'

export const deleteManyDefault: any = async (resource: any, params: any) => {
  for (let i = 0; i < params.ids.length; i++) {
    await client.getTable(resource).del({ id: params.ids[i] as string })
  }
  return { data: params.ids }
}
